import Constant from '@/const';
import axios from 'axios';

const deleteDrugs = async id => {
  try {
    const response = await axios.delete(
      Constant.apiUrl.concat(`/master/drugs/${id}`),
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default deleteDrugs;
